import gql from 'graphql-tag'

export default gql`
mutation deleteImg($type: ImgType!, $id: ID!) {
	cashAssist {
		deleteImg(type: $type, id: $id)
	}
}`
